<ngx-auth-firebaseui guestEnabled="false">
</ngx-auth-firebaseui>